const mFeedSectionEmpty = {
  mFeedSectionEmpty: {
    cardInfoButton: 'Crear',
    cardReference: 'crear',

    cardSubTitle: {
      projects: 'FORMACIÓN',
      products: 'PRODUCTO'
    },

    cardTitle: {
      products: 'Aquí podrás incluir el nombre de tu producto',
      projects: 'Aquí podrás incluir el nombre de tu formacion'
    }
  }
}

export default mFeedSectionEmpty
